import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PalantirAvatarComponent } from '../../../../avatar/avatar.component';
import { PalantirIconComponent } from '../../../../icon/icon.component';
import type { PalantirIcon } from '../../../../icon/icon.type';
import { PalantirTextComponent } from '../../../../text/text.component';
import type { PalantirTextType } from '../../../../text/text.type';
import { PalantirTextTypeEnum } from '../../../../text/text.type';
import type { PalantirFilterOption } from '../../../filter-modal.type';

@Component({
  selector: 'palantir-filter-modal-option',
  standalone: true,
  imports: [PalantirAvatarComponent, PalantirIconComponent, PalantirTextComponent],
  templateUrl: './option.component.html',
  styleUrl: './option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalantirFilterModalOptionComponent {
  public readonly option = input.required<PalantirFilterOption>();

  public readonly textType = input<PalantirTextType>(PalantirTextTypeEnum.text);

  public isOptionIconType(
    iconOrAvatar: PalantirFilterOption['iconOrAvatar'],
  ): iconOrAvatar is { color?: string; icon: PalantirIcon } {
    return Boolean(iconOrAvatar && (iconOrAvatar as { icon: PalantirIcon }).icon);
  }

  public isOptionAvatarType(
    iconOrAvatar: PalantirFilterOption['iconOrAvatar'],
  ): iconOrAvatar is { avatar: string } {
    return Boolean(iconOrAvatar && (iconOrAvatar as { avatar: string }).avatar);
  }
}
